import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {Grid} from '../../components/layout';
import {OnboardingFeatures} from '../../components/onboarding-features';
import {OnboardingForm} from '../../components/onboarding-form';

export const OnboardingPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get('ref') ?? undefined;

  return (
    <Grid cols={{lg: 2, sm: 1}}>
      <OnboardingFeatures />
      <OnboardingForm referralCode={referralCode} />
    </Grid>
  );
};
